import { render } from "./TrixComponent.vue?vue&type=template&id=7922fae1"
import script from "./TrixComponent.vue?vue&type=script&lang=js"
export * from "./TrixComponent.vue?vue&type=script&lang=js"

import "./TrixComponent.vue?vue&type=style&index=0&id=7922fae1&lang=css"

import exportComponent from "/tmp/build_905a1b4c/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__